export default function () {
    jQuery('.js-video--play').on('click', function () {
        jQuery(this).hide(300);
        jQuery(this).parent().removeClass('video-not-playing');
        
        var player = jQuery(this).siblings('iframe');
        var data = { method: 'play' };

        player[0].contentWindow.postMessage(JSON.stringify(data), '*');
    });

    function play_video() {
    }
}
